import { useEffect, useRef, useState } from "react";
import Layouts from "../../Layouts";
import { FaStar } from "react-icons/fa";
import NoDataFound from "../../../Assets/Icons/NoDataCard2.svg";
import FavMedService from "../../../Services/FavMedService";
import { message, Spin } from "antd";
import DrugServices from "../../../Services/DrugServices";
import { FaRegStar } from "react-icons/fa6";
import CommonFunctions from "../../Shared/CommonFunctions";
import Delete from "../../../Assets/Icons/delete.svg";

function FavMedicine() {
  const [searchVal, setSearchVal] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [medicineList, setMedicineList] = useState([]);

  const searchWrapperRef = useRef(null);
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    getFavMedicine();
  }, []);

  // Hide dropdown when clicking outside the search wrapper
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchWrapperRef.current &&
        !searchWrapperRef.current.contains(e.target)
      ) {
        setMedicineList([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Hide dropdown when search value is cleared
  useEffect(() => {
    if (!searchVal || searchVal.length < 3) {
      setMedicineList([]);
    }
  }, [searchVal]);

  const getFavMedicine = async () => {
    setLoading(true);
    let payload = {
      userId: loginResultObject.user.userId,
      status: 1,
    };
    try {
      let result = await FavMedService.GetFavMedicineList(payload);
      setTableData(result.data);
      setLoading(false);
    } catch (error) {
      console.error("Error", error);
      setLoading(false);
    }
  };

  const handleMedicineSearch = (value) => {
    setSearchVal(value);
    if (value && value.length > 2) {
      onSearchMedicine(value);
    } else {
      setMedicineList([]);
    }
  };

  const onSearchMedicine = async (value) => {
    let payload = {
      medicineName: value,
      pageNo: 1,
      size: 40,
      userId: loginResultObject.user.userId,
    };
    try {
      let result = await DrugServices.fetchDrugListnew(payload);
      setMedicineList(result.data.data);
    } catch (error) {
      console.error(error);
    }
  };


  const handleSelectedMedicine = async (medicine) => {
    let payload = {
      createdBy: loginResultObject.user.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      drugCode: medicine.code,
      drugName: medicine.medicineName,
      modifiedBy: loginResultObject.user.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      status: 1,
      userId: loginResultObject.user.userId,
    };

    try {
      let result = await FavMedService.SaveFavMedicine(payload);
      message.success(
        `${payload.drugName} is added to your favorite medicine List`
      );
      setSearchVal("");
      getFavMedicine();
    } catch (error) {
      message.error("An error occured try again");
    }
  };

  const handleRemove = async (record) => {
    record.modifiedBy = loginResultObject.user.userId;
    record.modifiedDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    record.status = 0;
    try {
      let result = await FavMedService.RemoveFavMedicine(record);
      message.success(
        `${record.drugName} is Removed from your favorite medicine List`
      );
      getFavMedicine();
    } catch (error) {
      message.error("Error occured try again");
    }
  };

  return (
    <Layouts>
      <div className="">
        <div className="flex flex-col h-full ">
          <div className="md:flex justify-between">
            <div className="font-bold my-2 ">Favorite Medicines</div>
          </div>
          <div className="md:flex justify-center">
            <div ref={searchWrapperRef} className="flex flex-col space-y-2 w-[40%] relative mt-2">
              <input
                value={searchVal}
                onChange={(e) => {
                  handleMedicineSearch(e.target.value);
                }}
                id="medicineName"
                type="text"
                name="Medicine Name"
                placeholder=""
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#959595] peer  focus:border-[#189FAA] bg-transparent"
              />
              <label
                htmlFor="medicineName"
                className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
              >
                Medicine Name
              </label>
              {medicineList.length > 0 && (
                <ul
                  className="absolute top-10 left-0 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-52 overflow-y-auto z-10"
                >
                  {medicineList.map((medicine, index) => (
                    <div className="flex p-2 justify-between hover:bg-gray-200">
                      <li
                        key={medicine.id || index}
                        className="px-2 py-1 text-[13px] font-sans  cursor-pointer w-[90%]"
                      >
                        {medicine.medicineName}
                      </li>
                      <li className="w-[10%] flex justify-center items-center cursor-pointer">
                        {/* <FaStar /> */}
                        <FaRegStar
                          onClick={() => handleSelectedMedicine(medicine)}
                        />
                      </li>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          </div>
          {loading ? (
            <div className="flex justify-center items-center mt-40">
              <Spin />
            </div>
          ) : (
            <div className="w-full overflow-x-auto overflow-y-auto">
              {tableData.length > 0 ? (
                <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
                  <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                    <tr className="font-sans font-normal">
                      <th className="p-3 whitespace-nowrap">Medicine Name</th>
                      <th className="p-3 whitespace-nowrap">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((record, index) => (
                      <tr
                        key={index}
                        className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                      >
                        <td className="p-3 whitespace-nowrap align-top">
                          {record.drugName}
                        </td>
                        <td className="p-3 whitespace-nowrap align-top flex gap-4">
                          <FaStar className="text-yellow-400" />
                          <img
                            src={Delete}
                            alt="Delete"
                            title="Remove from favorite"
                            className="w-5 h-5 cursor-pointer"
                            onClick={() => handleRemove(record)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="flex justify-center items-center">
                  <img src={NoDataFound} alt="No Data" className="h-[20rem]" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Layouts>
  );
}

export default FavMedicine;
